interface WaitingForPlayersProps {
  currentPlayerCount: number
  requiredPlayerCount: number
  supportsBots: boolean
}

export function WaitingForPlayers({
  currentPlayerCount,
  requiredPlayerCount,
  supportsBots
}: WaitingForPlayersProps) {

  return (
    <div className="absolute inset-0 bg-overlay flex items-center justify-center z-10">
      <div className="bg-surface rounded-lg p-8 max-w-md text-center shadow-lg">
        <h2 className="text-2xl font-bold mb-4">Waiting for Players</h2>
        <p className="text-primary mb-6">
          {currentPlayerCount} of {requiredPlayerCount} players joined
        </p>
        {!supportsBots && (
          <p className="text-sm text-muted">
            Share the room name with another player to start
          </p>
        )}
        {supportsBots && (
          <p className="text-sm text-muted">
            Use the "Add AI Player" button in the mate sidebar to add an AI opponent
          </p>
        )}
      </div>
    </div>
  )
}

